import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import { createPinia, PiniaVuePlugin } from 'pinia'
import VueCompositionAPI, {createApp} from '@vue/composition-api'
import vuetify from './plugins/vuetify'
import {wasticsStore} from "@/store";

Vue.use(PiniaVuePlugin)
const pinia = createPinia()
Vue.use(VueCompositionAPI)

Vue.config.productionTip = false
const app = createApp(App)
app.use(pinia)
const store = wasticsStore();
console.log(store.loggedIn);

new Vue({
  router,
  pinia,
  vuetify,
  render: h => h(App)
}).$mount('#app')